import StarsBackground from "@/components/StarsBackground";
import NebulaBackground from "@/components/NebulaBackground";
import CosmicLightningLayer from "@/components/CosmicLightningLayer";

interface CosmicLayoutProps {
  children: React.ReactNode;
}

const CosmicLayout = ({ children }: CosmicLayoutProps) => {
  return (
    <div 
      className="min-h-screen flex flex-col relative overflow-x-hidden"
      style={{ 
        // Fallback dark background in case layers fail to render
        backgroundColor: 'hsl(240 5% 12%)' 
      }}
    >
      <div className="fixed inset-0 pointer-events-none" aria-hidden="true" role="presentation">
        <NebulaBackground />
        <CosmicLightningLayer />
        <StarsBackground />
      </div>
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default CosmicLayout;
